import * as inquiryCreators from '../creators/inquiryCreators';

export default function locale(state = { lang: "no" }, action = {}) {
    switch (action.type) {
        case inquiryCreators.LOCALE_SET:
            return { lang: action.lang };
        default:
            return state;
    }
}